"use strict";

angular.module("licensure.helpers").factory("Resource", [
    "$q",
    "$window",
    function($q, $window) {
        var activeOptions = function() {
            var options = [];

            options.push({ id: true, name: "Active" });
            options.push({ id: false, name: "Inactive" });

            return options;
        };

        var environmentOptions = function() {
            var options = [];

            options.push({ id: true, name: "Public" });
            options.push({ id: false, name: "Internal" });

            return options;
        };

        var yesNoOptions = function() {
            var options = [];

            options.push({ id: true, name: "Yes" });
            options.push({ id: false, name: "No" });

            return options;
        };

        var dateOptions = function() {
            var options = [];

            options.push({ id: 0, name: "Today" });
            options.push({ id: 1, name: "Yesterday" });
            options.push({ id: 7, name: "Last 7 Days" });
            options.push({ id: 30, name: "Last 30 Days" });
            options.push({ id: 90, name: "Last 90 Days" });
            options.push({ id: 365, name: "Last Year" });
            options.push({ id: 730, name: "Last Two Years" });
            options.push({ id: 1095, name: "Last Three Years" });
            options.push({ id: -1, name: "Tomorrow" });
            options.push({ id: -7, name: "Next 7 Days" });
            options.push({ id: -30, name: "Next 30 Days" });
            options.push({ id: -90, name: "Next 90 Days" });
            options.push({ id: -365, name: "Next Year" });

            return options;
        };

        return {
            months: function() {
                var months = [];

                months.push({ id: 0, name: "January", abbrv: "Jan" });
                months.push({ id: 1, name: "February", abbrv: "Feb" });
                months.push({ id: 2, name: "March", abbrv: "Mar" });
                months.push({ id: 3, name: "April", abbrv: "Apr" });
                months.push({ id: 4, name: "May", abbrv: "May" });
                months.push({ id: 5, name: "June", abbrv: "Jun" });
                months.push({ id: 6, name: "July", abbrv: "Jul" });
                months.push({ id: 7, name: "August", abbrv: "Aug" });
                months.push({ id: 8, name: "September", abbrv: "Sep" });
                months.push({ id: 9, name: "October", abbrv: "Oct" });
                months.push({ id: 10, name: "November", abbrv: "Nov" });
                months.push({ id: 11, name: "December", abbrv: "Dec" });

                return months;
            },

            weekdays: function () {
                var weekdays = [];

                weekdays.push({ id: 0, name: 'Sunday', abbrv: 'Sun' });
                weekdays.push({ id: 1, name: 'Monday', abbrv: 'Mon' });
                weekdays.push({ id: 2, name: 'Tuesday', abbrv: 'Tues' });
                weekdays.push({ id: 3, name: 'Wednesday', abbrv: 'Wed' });
                weekdays.push({ id: 4, name: 'Thursday', abbrv: 'Thurs' });
                weekdays.push({ id: 5, name: 'Friday', abbrv: 'Fri' });
                weekdays.push({ id: 6, name: 'Saturday', abbrv: 'Sat' });

                return weekdays;
            },

            years: function (offset, span) {
                if (offset == undefined) { offset = 10; }
                if (span == undefined) { span = 20; }

                var years = [];

                var currentYear = new Date().getFullYear();

                for (
                    var i = currentYear - offset;
                    i < currentYear - offset + span + 1;
                    i++
                ) {
                    years.push({ id: i, name: i });
                }

                return years;
            },

            birthdate_duration: function () {
                var duration = [{ id: 1, name: 1 }, { id: 2, name: 2 }];
                return duration;
            },

            alpha: function() {
                var alpha = [];

                alpha.push({ id: "a", name: "A" });
                alpha.push({ id: "b", name: "B" });
                alpha.push({ id: "c", name: "C" });
                alpha.push({ id: "d", name: "D" });
                alpha.push({ id: "e", name: "E" });
                alpha.push({ id: "f", name: "F" });
                alpha.push({ id: "g", name: "G" });
                alpha.push({ id: "h", name: "H" });
                alpha.push({ id: "i", name: "I" });
                alpha.push({ id: "j", name: "J" });
                alpha.push({ id: "k", name: "K" });
                alpha.push({ id: "l", name: "L" });
                alpha.push({ id: "m", name: "M" });
                alpha.push({ id: "n", name: "N" });
                alpha.push({ id: "o", name: "O" });
                alpha.push({ id: "p", name: "P" });
                alpha.push({ id: "q", name: "Q" });
                alpha.push({ id: "r", name: "R" });
                alpha.push({ id: "s", name: "S" });
                alpha.push({ id: "t", name: "T" });
                alpha.push({ id: "u", name: "U" });
                alpha.push({ id: "v", name: "V" });
                alpha.push({ id: "w", name: "W" });
                alpha.push({ id: "x", name: "X" });
                alpha.push({ id: "y", name: "Y" });
                alpha.push({ id: "z", name: "Z" });

                return alpha;
            },

            activeOptions: activeOptions,
            yesNoOptions: yesNoOptions,

            getActiveOptions: function() {
                var d = $q.defer();

                d.resolve(activeOptions());

                return d.promise;
            },

            getEnvironmentOptions: function() {
                var d = $q.defer();

                d.resolve(environmentOptions());

                return d.promise;
            },

            getDateOptions: function() {
                var d = $q.defer();

                d.resolve(dateOptions());

                return d.promise;
            },

            browser: function() {
                var ua = navigator.userAgent,
                    tem,
                    M =
                        ua.match(
                            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
                        ) || [];
                if (/trident/i.test(M[1])) {
                    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                    return "IE " + (tem[1] || "");
                }
                if (M[1] === "Chrome") {
                    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                    if (tem != null)
                        return tem
                            .slice(1)
                            .join(" ")
                            .replace("OPR", "Opera");
                }
                M = M[2]
                    ? [M[1], M[2]]
                    : [navigator.appName, navigator.appVersion, "-?"];
                if ((tem = ua.match(/version\/(\d+)/i)) != null)
                    M.splice(1, 1, tem[1]);
                return M.join(" ");
            }
        };
    }
]);
